<ng-container *ngIf="!useSummaryView else summaryView">
    <div class="flex flex-col w-full" *ngIf="!field.hidden" animate.enter="fade-in">
        <div>
            <mat-label *ngIf="!field.browserOpts.inLineWithCaption">{{ field.label | localize }}</mat-label>
            <div>
                <ng-container *ngFor="let val of emojisValue">
                    <button class="mx-2" mat-icon-button (click)="markEmoji(val)">
                        <ng-container *ngIf="val.emoji === 'S'">
                            <ng-container *ngIf="!val.marked; else sadMarked">
                                <mat-icon class="text-red-600 scale-[2]" svgIcon="emoji-sad-outline"></mat-icon>
                            </ng-container>
                            <ng-template #sadMarked>
                                <mat-icon class="text-red-600 scale-[2]" svgIcon="emoji-sad-solid"></mat-icon>
                            </ng-template>
                        </ng-container>
                        <ng-container *ngIf="val.emoji === 'H'">
                            <ng-container *ngIf="!val.marked; else happyMarked">
                                <mat-icon class="text-green-500 scale-[2]" svgIcon="emoji-happy-outline"></mat-icon>
                            </ng-container>
                            <ng-template #happyMarked>
                                <mat-icon class="text-green-500 scale-[2]" svgIcon="emoji-happy-solid"></mat-icon>
                            </ng-template>
                        </ng-container>
                        <ng-container *ngIf="val.emoji === 'N'">
                            <ng-container *ngIf="!val.marked; else noneMarked">
                                <mat-icon class="text-amber-500 scale-[2]" svgIcon="emoji-none-outline"></mat-icon>
                            </ng-container>
                            <ng-template #noneMarked>
                                <mat-icon class="text-amber-500 scale-[2]" svgIcon="emoji-none-solid"></mat-icon>
                            </ng-template>
                        </ng-container>
                    </button>
                </ng-container>
            </div>
            <ng-container *ngIf="field.control.errors">
                <div *ngIf="field.control.hasError('incorrect')"
                    class="text-sm text-warn leading-none font-medium mt-2">
                    {{ 'errorRequiredField' | transloco }}
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>

<ng-template #summaryView>
    <ng-container *ngFor="let val of emojisValue">
        <button mat-icon-button (click)="markEmoji(val)">
            <ng-container *ngIf="val.emoji === 'S'">
                <ng-container *ngIf="!val.marked; else sadMarked">
                    <mat-icon svgIcon="emoji-sad-outline"></mat-icon>
                </ng-container>
                <ng-template #sadMarked>
                    <mat-icon svgIcon="emoji-sad-solid" color="danger"></mat-icon>
                </ng-template>
            </ng-container>
            <ng-container *ngIf="val.emoji === 'H'">
                <ng-container *ngIf="!val.marked; else happyMarked">
                    <mat-icon svgIcon="emoji-happy-outline"></mat-icon>
                </ng-container>
                <ng-template #happyMarked>
                    <mat-icon svgIcon="emoji-happy-solid"></mat-icon>
                </ng-template>
            </ng-container>
            <ng-container *ngIf="val.emoji === 'N'">
                <ng-container *ngIf="!val.marked; else noneMarked">
                    <mat-icon svgIcon="emoji-none-outline"></mat-icon>
                </ng-container>
                <ng-template #noneMarked>
                    <mat-icon svgIcon="emoji-none-solid"></mat-icon>
                </ng-template>
            </ng-container>
        </button>
    </ng-container>
</ng-template>